import { StringUtility } from '@common/utils';
import {
  BusinessLineModel,
  IBusinessLineModel,
  ITemplateTypeModel,
} from '@common/models';
import { IModel, ModelRecord, Model } from './Model';
import { TemplateTypeModel } from './TemplateTypeModel';
import { defaultTo } from 'lodash';

export interface ITemplateModel extends IModel {
  templateId: number;
  name: string | undefined;
  templateValue: string | undefined;
  description: string | undefined;
  templateTypeId: number;
  enabled: boolean;
  showEnabledInAdmin: boolean;
  sortOrder: number;
  templateType: ITemplateTypeModel;
  dateCreated: string;
  dateUpdated: string | undefined;
  TemplateMaxSize: number | undefined;
  businessLine: IBusinessLineModel;
  placeholders: string | undefined;
  businessLineId: number | undefined;
}

export class TemplateModel
  extends Model
  implements ModelRecord<ITemplateModel>
{
  templateId: number;
  name: string;
  templateValue: string;
  description: string;
  templateTypeId: number;
  enabled: boolean;
  showEnabledInAdmin: boolean;
  sortOrder: number;
  templateType: TemplateTypeModel;
  dateUpdated: string;
  dateCreated: string;
  TemplateMaxSize: number;
  businessLine: BusinessLineModel;
  placeholders: string | undefined;
  businessLineId: number | undefined;

  constructor(params?: Partial<ITemplateModel>) {
    super(params);
    this.templateId = defaultTo(params?.templateId, 0);
    this.name = defaultTo(
      StringUtility.SanitizeStringWithEmpty(params?.name),
      '',
    );
    this.templateValue = defaultTo(
      StringUtility.SanitizeStringWithEmpty(params?.templateValue),
      '',
    );
    this.description = defaultTo(
      StringUtility.SanitizeStringWithEmpty(params?.description),
      '',
    );
    this.templateTypeId = defaultTo(params?.templateTypeId, 0);
    this.enabled = defaultTo(params?.enabled, false);
    this.showEnabledInAdmin = defaultTo(params?.showEnabledInAdmin, false);
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.templateType = params?.templateType
      ? new TemplateTypeModel(params?.templateType)
      : new TemplateTypeModel();
    this.dateUpdated =
      defaultTo(params?.dateUpdated, params?.dateCreated) ?? '';
    this.dateCreated = params?.dateCreated ?? '';
    this.TemplateMaxSize = defaultTo(params?.TemplateMaxSize, 10000);
    this.businessLine = params?.businessLine
      ? new BusinessLineModel(params?.businessLine)
      : new BusinessLineModel();
    this.placeholders = defaultTo(params?.placeholders, '');
    this.businessLineId = defaultTo(params?.businessLineId, 0);
  }
}
